import React, { useState } from 'react';
import useChatStore from '../../stores/useChatStore';

export interface FlerpieRemember {
  id: string;
  fact: string;
  forgotten?: boolean;
}

const FlerpieRememberLine = ({ messageId, remember }: { messageId: string; remember: FlerpieRemember }) => {
  const [busy, setBusy] = useState(false);
  const [forgottenHere, setForgottenHere] = useState(false);
  const [failed, setFailed] = useState(false);

  const undo = async () => {
    if (busy) return;
    setBusy(true);
    setFailed(false);
    const ok = await useChatStore.getState().forgetFact(remember.id, messageId);
    setBusy(false);
    if (ok) setForgottenHere(true);
    else setFailed(true);
  };

  if (remember.forgotten || forgottenHere) {
    return <div className="mt-1.5 text-[10px] text-gray-500">Forgotten.</div>;
  }

  return (
    <div className="mt-1.5 text-[10px] text-gray-500">
      Flerpie will remember this: {remember.fact}{' '}
      <button
        type="button"
        onClick={undo}
        disabled={busy}
        className="text-primary hover:underline focus-visible:underline outline-none px-1 -mx-1 py-0.5 rounded disabled:opacity-60"
      >
        {busy ? 'Undoing...' : 'Undo'}
      </button>
      {failed && <span className="ml-1 text-red-300">That did not undo. Try again.</span>}
    </div>
  );
};

export default FlerpieRememberLine;
